/**
 * @flow
 */
import { Box, Chip } from '@mui/material';
import Grid from '@mui/material/Grid';
import PoundIcon from 'mdi-react/PoundIcon';
import React from 'react';

const styles = {
  root: { width: '80vw' },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  chip: {
    borderRadius: '6px',
  },
};

type Props = {| title: String, number: Number |};

const DrawerTitle = (props: Props) => (
  <Grid container sx={styles.root} spacing={4}>
    <Grid sx={styles.title} size={7}>
      <Box>{props.title}</Box>
      <Box>
        <Chip
          variant="soft"
          color="primary"
          icon={<PoundIcon size={16} />}
          label={props.number}
          sx={styles.chip}
        />
      </Box>
    </Grid>
  </Grid>
);

export default DrawerTitle;
